import React, { FC, ReactNode } from "react";
import { Grid, GridItem } from "@UI/Components/Grid/Grid";

interface Props {
  linksLeft: ReactNode;
  linksCenter: ReactNode;
  linksRight: ReactNode;
  socialLinks: ReactNode;
}

export const FooterLinksGrid: FC<Props> = ({
  linksLeft,
  linksCenter,
  linksRight,
  socialLinks,
}) => {
  return (
    <Grid
      gridTemplateColumns={{
        base: "1fr 1fr",
        md: "1fr 1fr 1fr",
        lg: "1fr 1fr 1fr 300px",
      }}
      paddingBottom="6"
      rowGap="10"
      columnGap="6"
    >
      <GridItem>{linksLeft}</GridItem>
      <GridItem>{linksCenter}</GridItem>
      <GridItem>{linksRight}</GridItem>
      <GridItem
        rowStart={{ base: 3, md: 2, lg: 1 }}
        colSpan={{ base: 2, md: 3, lg: 1 }}
        colStart={{ base: 1, lg: 4 }}
      >
        {socialLinks}
      </GridItem>
    </Grid>
  );
};
